
//These are here because we wanted them to appear above the compiled scss. There seems to be an option of creating an config file, or moving them here
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { Component, Vue, Watch } from "vue-property-decorator";
import NavBar from "./components/NavBar.vue";

@Component({
  components: {
    NavBar,
  },
})
class App extends Vue {
  get isEditing(): boolean {
    if (
      this.$store.state.gameStore.isEditing ||
      this.$store.state.cityStore.isEditing ||
      this.$store.state.gameStore.isGameEditing
    ) {
      return true;
    } else {
      return false;
    }
  }
  get isAuthenicated(): boolean {
    if (
      this.$store.state.authenication.userData.email &&
      !this.$store.state.authenication.weakPassword
    ) {
      return true;
    }
    return false;
  }

  get getIsIdle(): boolean {
    return this.$store.state.idleVue.isIdle;
  }

  created(): void {
    this.$store.commit("gameStore/currentlyEditing", false);
    this.$store.commit("gameStore/currentlyGameEditing", false);
    this.$store.commit("cityStore/currentlyEditing", false);
    this.$store.commit("mapPoiStore/currentlyEditing", false);
    if (this.isAuthenicated) {
      this.loadInitialData();
    }
  }

  loadInitialData(): void {
    this.$store.commit("gameStore/game", []);
    this.$store.commit("gameStore/historyGame", []);
    this.$store.commit("cityStore/setCities", []);
    this.$store.dispatch("gameStore/getAllGames");
    this.$store.dispatch("cityStore/getCities");
  }

  @Watch("isAuthenicated")
  getData(value: boolean): void {
    if (value) {
      this.loadInitialData();
    }
  }
  @Watch("getIsIdle")
  isIdle(value: boolean): void {
    if (value && this.isAuthenicated) {
      this.$store.commit("gameStore/currentlyEditing", false);
      this.$store.commit("gameStore/currentlyGameEditing", false);
      this.$store.commit("cityStore/currentlyEditing", false);
      this.$store.commit("mapPoiStore/currentlyEditing", false);
      this.$store.dispatch("authenication/userLogoutAsync");
    }
  }
}

export default App;
